// @<COPYRIGHT>@
// ==================================================
// Copyright 2024.
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@
export class DesAccConstants {
    static ACC_SESSION_ID = 'acc-session-id';
    // Locale
    static LOCALE = 'locale';
    // Container
    static CONTAINER_ID = 'container-id';
    static CONTAINER_TYPE = 'container-type';
    static FOLDER_ID = 'folder-id';

    // Collaboration space
    static COLLABORATION_SPACE_ID = 'collaborationspace-id';

    // Misc
    static STAGING_AREA_TYPE = 'staging-area-type';
    static ME = 'me';
    static HOME = 'home';

    // Team
    static TEAM_ID = 'team-id';
}
